/* eslint-disable @typescript-eslint/no-explicit-any */
import { GridColDef, GridRenderCellParams } from '@mui/x-data-grid-premium';
import { baseCell, booleanCell } from 'components/cells';
import DataGridCell from 'components/cells/DataGridCell';
import { filterOperators } from 'components/enhanced';
import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';

export const CostReport = (): GridColDef[] => {
  const translationPrefix = 'entities.cost_report';
  const { t } = useTranslation();
  return [
    {
      field: 'id',

      headerName: t(`global.code`),
      renderCell: baseCell
      // renderCell: (params: GridRenderCellParams) => {
      //   const reportId = params.value;
      //   return (
      //     <Link to={`${reportId}`}>
      //       <b className="text-secondary-500">{reportId}</b>
      //     </Link>
      //   );
      // }
    },
    {
      field: 'date_start',
      type: 'dateTime',
      headerName: t(`${translationPrefix}.date_start`),
      width: 150,
      filterOperators,
      valueGetter: ({ value }) => (value ? new Date(value) : null),
      renderCell: (params) => {
        if (!params.value) return '';
        return dayjs(params.value).format('DD/MM/YYYY');
      }
    },
    {
      field: 'date_end',
      type: 'date',
      headerName: t(`${translationPrefix}.date_end`),
      width: 150,
      filterOperators,
      valueGetter: ({ value }) => (value ? new Date(value) : null),
      renderCell: (params) => {
        if (!params.value) return '';
        return dayjs(params.value).format('DD/MM/YYYY');
      }
    },
    {
      field: 'created_by',
      headerName: t(`global.created_by`),
      width: 300,
      filterOperators,
      renderCell: baseCell
    },
    {
      field: 'status',
      headerName: t(`${translationPrefix}.status`),
      width: 100,
      filterOperators,
      renderCell: (params: GridRenderCellParams<any, any>) => (
        <DataGridCell content={t(`${translationPrefix}.status-${params.value}`)} />
      )
    },
    {
      field: 'validated',
      headerName: t(`${translationPrefix}.validated`),
      width: 100,
      type: 'boolean',
      editable: true,
      renderCell: booleanCell(t)
    }
  ];
};
